var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/filter_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6001 4.09998V6.29998C20.6001 7.09998 20.1001 8.09998 19.6001 8.59998L15.3001 12.4C14.7001 12.9 14.3001 13.9 14.3001 14.7V19C14.3001 19.6 13.9001 20.4 13.4001 20.7L12.0001 21.6C10.7001 22.4 8.9001 21.5 8.9001 19.9V14.6C8.9001 13.9 8.5001 13 8.1001 12.5L7.1001 11.45L12.9201 2.09998H18.6001C19.7001 2.09998 20.6001 2.99998 20.6001 4.09998Z",
    fill: "#010066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M11.2999 2.09998L6.1199 10.41L4.2999 8.49998C3.7999 7.99998 3.3999 7.09998 3.3999 6.49998V4.19998C3.3999 2.99998 4.2999 2.09998 5.3999 2.09998H11.2999Z",
    fill: "#010066"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4c75eeeb5ee0a5b159ca1411ad113d77.svg";
export { ForwardRef as ReactComponent };